import AWSIcon from './aws.svg'
import Go from './go.svg'
import GraphQL from './graphql.svg'
import MongoDB from './mongodb.svg'
import NextJs from './nextjs.svg'
import NodeJs from './nodejs.svg'
import PostgreSQL from './postgresql.svg'
import ReactLogo from './react.svg'
import Remix from './remix.svg'
import TypeScript from './typescript.svg'

// Icons taken from: https://devicon.dev/

const Components = {
  typescript: TypeScript,
  go: Go,
  graphql: GraphQL,
  react: ReactLogo,
  mongodb: MongoDB,
  nodejs: NodeJs,
  postgresql: PostgreSQL,
  remix: Remix,
  nextjs: NextJs,
  aws: AWSIcon,
}

const DevIcon = ({ kind, size = 6 }) => {
  const SocialSvg = Components[kind]

  return (
    <span>
      <span className="sr-only">{kind} icon</span>
      <SocialSvg className={`fill-current h-${size} w-${size}`} />
    </span>
  )
}

export default DevIcon
